module.exports = __webpack_public_path__ + "static/media/hire-signup.424d5151.svg";